import axios from 'axios';
import {apiBaseUrl} from '../../../helpers/UrlHelper'
import {handleError} from "../../../helpers/ErrorHelper";

function _success(success) {
    return {type: 'GET_ACTIVITY_EVENT_SUCCESS', success};
}

function _error(error) {
    return {type: 'GET_ACTIVITY_EVENT_ERROR', error};
}

function _processing(processing) {
    return {type: 'GET_ACTIVITY_EVENT_PROCESSING', processing};
}

function getActivityEvents() {
    return (dispatch) => {
        dispatch(_processing(true));
        dispatch(_error(null));
        axios({
            url: apiBaseUrl(`admin/events`),
            method: "get",
            dataType: 'json',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem(`Bearer`)
            }
        }).then(function (res) {
            dispatch(_processing(false));
            dispatch(_success(res));

        }).catch(function (error) {
            handleError(error);
            dispatch(_error(error));
            dispatch(_processing(false));
        });
    }
}

export default getActivityEvents;
